import { render, staticRenderFns } from "./UseGoods.vue?vue&type=template&id=064d4202&scoped=true"
import script from "./UseGoods.vue?vue&type=script&lang=js"
export * from "./UseGoods.vue?vue&type=script&lang=js"
import style0 from "./UseGoods.vue?vue&type=style&index=0&id=064d4202&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064d4202",
  null
  
)

export default component.exports